import React, { useState, useEffect, useRef } from 'react';
import Sidebar from './Sidebar';
import TopNavbar from '../top-navbar/TopNav';
import '../../styles/employee/CriminalCheck.css';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Loader from '../loader/Loader';
import { saveCriminalCheck,updateCriminalCheckStatus } from '../../services/employee/api';

const indianStates = [
  "Andhra Pradesh","Arunachal Pradesh",  "Assam",  "Bihar",  "Chhattisgarh",  "Goa",  "Gujarat",  "Haryana",  "Himachal Pradesh",
  "Jharkhand",  "Karnataka",  "Kerala",  "Madhya Pradesh",  "Maharashtra",  "Manipur",  "Meghalaya",  "Mizoram",  "Nagaland","Orissa",
  "Odisha",  "Punjab",  "Rajasthan",  "Sikkim",  "Tamil Nadu",  "Telangana",  "Tripura",  "Uttar Pradesh",  "Uttarakhand",
  "West Bengal",  "Andaman and Nicobar Islands",  "Chandigarh",  "Dadra and Nagar Haveli and Daman and Diu",  "Delhi",
  "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry" ];
const CriminalCheck = ({ candidateId, onBack }) => {
    const [fullname, setFullname] = useState('');
    const [fathername, setFathername] = useState('');
    const [year, setYear] = useState('');
    const [address, setAddress] = useState('');
    const [state, setState] = useState('');
    const [ecourtResults, setEcourtResults] = useState([]);
    const [formError, setFormError] = useState('')
    const[isLoading, setIsLoading] = useState(false);
    const [showViewMore, setShowViewMore] = useState(false);
    const [modalCaseDetails, setModalCaseDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const mainTableHeadRef = useRef(null);
    const mainTableBodyRef = useRef(null);
    const modalTableHeadRef = useRef(null);
    const modalTableBodyRef = useRef(null);
    const [isSuccessEnabled, setIsSuccessEnabled] = useState(false);
    const [isFailEnabled, setIsFailEnabled] = useState(false);
    const [errors, setErrors] = useState({});
    const nameRegex = /^[A-Za-z\s]+$/;
    const yearRegex = /^\d{4}$/;

    const adjustColumnWidths = (headRef, bodyRef) => {
        if (headRef.current && bodyRef.current) {
            const headerCells = headRef.current.querySelectorAll('th');
            const bodyRows = bodyRef.current.querySelectorAll('tr');

            if (headerCells.length > 0 && bodyRows.length > 0) {
                const firstBodyRowCells = bodyRows[0].querySelectorAll('td');
                if (firstBodyRowCells.length === headerCells.length) {
                    let totalWidth = 0;
                    const widths = Array.from(headerCells).map((th, index) => {
                        const width = th.offsetWidth;
                        totalWidth += width;
                        return width;
                    });

                    headerCells.forEach((th, index) => {
                        th.style.width = `${widths[index]}px`;
                        th.style.minWidth = `${widths[index]}px`;
                    });

                    bodyRows.forEach(row => {
                        const cells = row.querySelectorAll('td');
                        cells.forEach((td, index) => {
                            if (widths[index]) {
                                td.style.width = `${widths[index]}px`;
                                td.style.minWidth = `${widths[index]}px`;
                            }
                        });
                    });

                    headRef.current.closest('table').style.width = `${totalWidth}px`;
                    headRef.current.closest('table').style.minWidth = `${totalWidth}px`;
                }
            }
        }
    };

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (ecourtResults.length > 0) {
                adjustColumnWidths(mainTableHeadRef, mainTableBodyRef);
            }
            if (isModalOpen && modalCaseDetails && modalCaseDetails.length > 0) {
                adjustColumnWidths(modalTableHeadRef, modalTableBodyRef);
            }
        });

        const mainTableWrapper = document.querySelector('.criminal-main-table-container');
        if (mainTableWrapper) {
            resizeObserver.observe(mainTableWrapper);
        }

        const modalBody = document.querySelector('.criminal-modal-body-custom');
        if (modalBody) {
            resizeObserver.observe(modalBody);
        }

        return () => resizeObserver.disconnect();
    }, [ecourtResults, isModalOpen, modalCaseDetails]);

    useEffect(() => {
        if (ecourtResults.length > 0) {
            adjustColumnWidths(mainTableHeadRef, mainTableBodyRef);
        }
    }, [ecourtResults]);

    useEffect(() => {
        if (isModalOpen && modalCaseDetails && modalCaseDetails.length > 0) {
            const timer = setTimeout(() => {
                adjustColumnWidths(modalTableHeadRef, modalTableBodyRef);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [isModalOpen, modalCaseDetails]);

    const validateForm = () => {
        const newErrors = {};

        if (!fullname.trim()) {
            newErrors.fullname = "Full Name is required";
        } else if (!nameRegex.test(fullname)) {
            newErrors.fullname = "Only alphabets allowed";
        }

        if (!fathername.trim()) {
            newErrors.fathername = "Father Name is required";
        } else if (!nameRegex.test(fathername)) {
            newErrors.fathername = "Only alphabets allowed";
        }

        if (!year.trim()) {
            newErrors.year = "Year is required";
        } else if (!yearRegex.test(year)) {
            newErrors.year = "Enter a valid 4-digit year";
        }

        if (!address.trim()) {
            newErrors.address = "Address is required";
        }

        if (!state) {
           newErrors.state = "State is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
   };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fix the highlighted errors");
            setIsLoading(false);
            return;
        }
        setIsLoading(true);

        const requestData = {
            name: fullname,
            father_name: fathername,
            year: year,
            address: address,
            state: state,
        };

        try {
           
            
            const response = await fetch('https://kyc-api.surepass.app/api/v1/ecourts/ecourt-search-v2', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8',
                    'Content-Type': 'application/json',
                    'Tenant-Id': 'main',
                },
                body: JSON.stringify(requestData),
            });

            const responseData = await response.json();
            

            // const responseData = {
            //     success: true,
            //     data: {
            //         result: [
                        
            //             {
            //                 year: '2020',
            //                 petitioner: 'John Doe with a very very long name that might overflow and needs wrapping',
            //                 respondent: 'Jane Smith who is also having an extremely long name that will definitely wrap and cause issues',
            //                 respondent_address: '123 Main St, Anytown, Some District, Very Long City Name, State 12345, This address is quite long and should span multiple lines if needed.',
            //                 state: 'California',
            //                 filing_number: 'FN12345-ABC-DEF-GHI-JKL-MNO-PQR',
            //                 case_name: 'The People of the State of California vs. John Doe for the unauthorized use of public property and disturbing the peace',
            //                 case_status: 'Closed and archived',
            //                 case_no: 'C-2020-001-XYZ-987-654',
            //                 case_type: 'Civil Dispute',
            //                 fir_link: 'https://example.com/fir/123-long-fir-link-document-name-v1.pdf'
            //             },
            //             {
            //                 year: '2021',
            //                 petitioner: 'Acme Corporation Ltd.',
            //                 respondent: 'Widgets Inc. and its subsidiaries',
            //                 respondent_address: '456 Oak Avenue, Suite 100, Industrial Park, Metropolis, Some Other State 67890. This is a shorter address.',
            //                 state: 'New York',
            //                 filing_number: 'FN67890-XYZ-UVW-123-456',
            //                 case_name: 'Acme Corp v. Widgets Inc: Breach of Contract and Intellectual Property Infringement Claims',
            //                 case_status: 'Active and awaiting hearing after several postponements',
            //                 case_no: 'C-2021-005-ABC-DEF-789',
            //                 case_type: 'Commercial Litigation',
            //                 fir_link: null
            //             },
            //             {
            //                 year: '2019',
            //                 petitioner: 'Alice Johnson-Patterson',
            //                 respondent: 'Bob Williams-Thompson and family',
            //                 respondent_address: '789 Pine Lane, Village Green, Rural Area, Countryside, Another State 11223. A moderately long address.',
            //                 state: 'Texas',
            //                 filing_number: 'FN98765-PQR-STU-000-111',
            //                 case_name: 'Johnson-Patterson v. Williams-Thompson: A protracted legal battle over a family heirloom and property rights with complex implications',
            //                 case_status: 'Dismissed with prejudice',
            //                 case_no: 'C-2019-010-LMN-OPQ-222',
            //                 case_type: 'Family Law',
            //                 fir_link: 'https://example.com/fir/987-another-long-fir-link-pdf.pdf'
            //             },
            //             {
            //                 year: '2022',
            //                 petitioner: 'Government of India through its various ministries and departments',
            //                 respondent: 'Rahul Sharma and Associates LLP',
            //                 respondent_address: 'Block B, Sector 15, Dwarka, New Delhi 110078, India. This is a typical Indian address.',
            //                 state: 'Delhi',
            //                 filing_number: 'CR-2022-003-RST-UVX-333',
            //                 case_name: 'State v. Sharma: Corruption Charges and Public Misappropriation of Funds Case Number CR-2022-003-RST-UVX-333',
            //                 case_status: 'Under Trial and currently in the evidence presentation phase',
            //                 case_no: 'CR-2022-003',
            //                 case_type: 'Criminal Case',
            //                 fir_link: 'https://example.com/fir/456-criminal-case-details.pdf'
            //             },
            //             {
            //                 year: '2023',
            //                 petitioner: 'Priya Singh represented by Legal Aid Society',
            //                 respondent: 'Developers Ltd. and its CEO, Mr. Kumar',
            //                 respondent_address: 'Tech Park, Building 5, Marathahalli, Bangalore 560037, Karnataka, India. Another detailed address example.',
            //                 state: 'Karnataka',
            //                 filing_number: 'CC-2023-012-DEF-GHI-444',
            //                 case_name: 'Singh v. Developers Ltd.: Consumer Protection Case regarding incomplete property development and delayed possession with a long and detailed description',
            //                 case_status: 'Pending judgment after final arguments and submissions are completed',
            //                 case_no: 'CC-2023-012',
            //                 case_type: 'Consumer Dispute',
            //                 fir_link: null
            //             }
            //         ]
            //     }
            // };

            if (responseData.success === true && responseData.data?.result) {
                setEcourtResults(responseData.data.result);
                setShowViewMore(responseData.data.result.length > 0);
                setIsSuccessEnabled(true);
                setIsFailEnabled(true); 
                if (responseData.data.result.length === 0) {
                    toast.success('No records found.');
                    setIsSuccessEnabled(true);
                    setIsFailEnabled(false);
                }
            } else {
                toast.error('Unexpected response: ' + JSON.stringify(responseData));
                setEcourtResults([]);
                setShowViewMore(false);
            }
            setIsLoading(false);
        } catch (error) {
            toast.error('Server Error. Contact support if the error persists.', {
                autoClose: 3000,
            });
            setEcourtResults([]);
            setShowViewMore(false);
            setIsLoading(false);
        }
    };

    const token = localStorage.getItem("bgc_token");

const handleSaveRecord = async (record) => {
     setIsLoading(true);
    const payload = {
        candidateId: candidateId,
        year: record.year || '',
        petitioner: record.petitioner || '',
        respondent: record.respondent || '',
        respondent_address: record.respondent_address || '',
        state: record.state || '',
        filingNumber: record.filing_number || '',
        caseName: record.case_name || '',
        caseStatus: record.case_status || '',
        caseNumber: record.case_no || '',
        caseType: record.case_type || '',
        firlink: record.fir_link || ''
    };

    try {
        const response = await saveCriminalCheck(payload);
        setIsLoading(false);
        toast.success("Criminal Check data saved successfully", {
            autoClose: 3000,
        });
        setIsSuccessEnabled(false);
        setIsFailEnabled(true);
    } catch (error) {
        setIsLoading(false)
        const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Failed to save record";
        toast.error(errorMessage, {
            autoClose: 3000,
        });
    }
};

    const handleViewMore = () => {
        setModalCaseDetails(ecourtResults);
        setIsModalOpen(true);
    };

    const updateCriminalStatus = async (status, message) => {
      try {
        const response = await updateCriminalCheckStatus(candidateId, status, message);
        toast.success(response.data?.message || "Status updated successfully", {
            autoClose: 3000,
        });
        onBack();
        } catch (error) {
        const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Error updating status";
        toast.error(errorMessage, {
            autoClose: 3000,
        });
        }
    };

   return (
    <div className="criminal-dashboard-app-container">
          {isLoading && <Loader />}
        <Sidebar />
        <div className="criminal-dashboard-right-panel">
            <TopNavbar />
            <div className="criminal-wrapper">
                <div className="criminal-content-wrapper">
                    <section className="criminal-main">
                        <form id="ecourtForm" className="criminal-form-card" onSubmit={handleSubmit}>
                            <button className="criminal-check-cancel-button" onClick={onBack}>
                            &larr; Back
                            </button>
                            <input type="hidden" id="candidateId" name="candidateId" value={candidateId} />
                            <p className="criminal-form-title">Criminal Check</p>
                            <div className="criminal-form-grid">
                                <div className="criminal-form-group">
                                    <label htmlFor="fullname" className="criminal-form-label">Full Name <span className="criminal-text-danger">*</span></label>
                                   <input
                                    type="text"
                                    className="criminal-form-control"
                                    value={fullname}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(value)) {
                                            setFullname(value);
                                            setErrors({ ...errors, fullname: "" });
                                        }
                                    }}
                                />
                                {errors.fullname && <small className="criminal-check-error">{errors.fullname}</small>}

                                </div>
                                <div className="criminal-form-group">
                                    <label htmlFor="fathername" className="criminal-form-label">Father Name <span className="criminal-text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="criminal-form-control"
                                        value={fathername}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                setFathername(value);
                                                setErrors({ ...errors, fathername: "" });
                                            }
                                        }}
                                    />
                                    {errors.fathername && <small className="criminal-check-error">{errors.fathername}</small>}

                                </div>
                                <div className="criminal-form-group">
                                    <label htmlFor="year" className="criminal-form-label">Year <span className="criminal-text-danger">*</span></label>
                                   <input
                                        type="text"
                                        className="criminal-form-control"
                                        maxLength="4"
                                        value={year}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                setYear(value);
                                                setErrors({ ...errors, year: "" });
                                            }
                                        }}
                                    />
                                    {errors.year && <small className="criminal-check-error">{errors.year}</small>}

                                </div>
                                <div className="criminal-form-group">
                                    <label htmlFor="address" className="criminal-form-label">Address <span className="criminal-text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="criminal-form-control"
                                        value={address}
                                        onChange={(e) => {
                                            setAddress(e.target.value);
                                            setErrors({ ...errors, address: "" });
                                        }}
                                    />
                                    {errors.address && <small className="criminal-check-error">{errors.address}</small>}
                                </div>
                                <div className="criminal-form-group">
                                    <label htmlFor="state" className="criminal-form-label">State <span className="criminal-text-danger">*</span></label>
                                    <select
                                        className="criminal-form-control"
                                        value={state}
                                        onChange={(e) => {
                                           setState(e.target.value);
                                           setErrors({ ...errors, state: "" });
                                        }}
                                    >
                                        <option value="">-- Select State --</option>
                                        {indianStates.map((st, index) => (
                                            <option key={index} value={st}>
                                               {st}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.state && <small className="criminal-check-error">{errors.state}</small>}

                                </div>
                            </div>
                            <button type="submit" className="criminal-btn criminal-btn-primary criminal-submit-btn">Submit</button>
                        </form>

                        <div className="criminal-card">
                            <h6 className="criminal-card-title">Ecourt Records</h6>
                            <div className="criminal-main-table-container">
                                <table className="criminal-table">
                                    <thead ref={mainTableHeadRef}>
                                        <tr>
                                            <th>Year</th>
                                            <th>Petitioner</th>
                                            <th>Respondent</th>
                                            <th>Respondent Address</th>
                                            <th>State</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody ref={mainTableBodyRef}>
                                        {ecourtResults.length > 0 ? (
                                            ecourtResults.map((record, index) => (
                                                <tr key={index}>
                                                    <td>{record.year}</td>
                                                    <td>{record.petitioner}</td>
                                                    <td>{record.respondent}</td>
                                                    <td>{record.respondent_address}</td>
                                                    <td>{record.state}</td>
                                                    <td>
                                                        <button className="criminal-btn criminal-btn-success criminal-btn-sm" onClick={() => handleSaveRecord(record)} type="button">Save</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="criminal-no-data">
                                                    {formError === 'No records found.' ? 'No records found.' : 'Submit the form to see results.'}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                            {ecourtResults.length > 0 && (
                                <div className="criminal-actions">
                                    {showViewMore && (
                                        <button className="criminal-btn criminal-btn-info" onClick={handleViewMore} type="button">View More</button>
                                    )}
                                    <div className="criminal-status-actions">
                                    <button
                                        type="button"
                                        className="criminal-btn criminal-btn-success"
                                        onClick={() => updateCriminalStatus('SUCCESS', 'There is No Criminal Record')}
                                        disabled={!isSuccessEnabled} // Disabled based on isSuccessEnabled state
                                    >
                                        Success
                                    </button>
                                    <button
                                        type="button"
                                        className="criminal-btn criminal-btn-danger"
                                        onClick={() => updateCriminalStatus('FAIL', 'There is Criminal Record found for the Candidate')}
                                        disabled={!isFailEnabled} // Disabled based on isFailEnabled state
                                    >
                                        Fail
                                    </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </div>

            {isModalOpen && (
                <div className="criminal-modal-backdrop-custom">
                    <div className="criminal-modal-custom">
                        <div className="criminal-modal-content-custom">
                            <div className="criminal-modal-header-custom">
                                <h5 className="criminal-modal-title">Full Case Details</h5>
                                <button type="button" className="criminal-close-custom" onClick={() => setIsModalOpen(false)}>&times;</button>
                            </div>
                            <div className="criminal-modal-body-custom">
                                <div className="criminal-table-wrapper">
                                    <table className="criminal-table">
                                        <thead ref={modalTableHeadRef}>
                                            <tr>
                                                <th>Year</th>
                                                <th>Petitioner</th>
                                                <th>Respondent</th>
                                                <th>Respondent Address</th>
                                                <th>State</th>
                                                <th>Filing Number</th>
                                                <th>Case Name</th>
                                                <th>Case Status</th>
                                                <th>Case Number</th>
                                                <th>Case Type</th>
                                                <th>FIR Link</th>
                                            </tr>
                                        </thead>
                                        <tbody ref={modalTableBodyRef}>
                                            {modalCaseDetails && modalCaseDetails.length > 0 ? (
                                                modalCaseDetails.map((record, index) => (
                                                    <tr key={index}>
                                                        <td>{record.year}</td>
                                                        <td>{record.petitioner}</td>
                                                        <td>{record.respondent}</td>
                                                        <td>{record.respondent_address}</td>
                                                        <td>{record.state}</td>
                                                        <td>{record.filing_number}</td>
                                                        <td>{record.case_name}</td>
                                                        <td>{record.case_status}</td>
                                                        <td>{record.case_no}</td>
                                                        <td>{record.case_type}</td>
                                                        <td>{record.fir_link ? <a href={record.fir_link} target="_blank" rel="noopener noreferrer">View</a> : ''}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="11" className="criminal-no-data">No details available.</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
);
};

CriminalCheck.propTypes = {
        candidateId: PropTypes.string.isRequired,
        onBack: PropTypes.func.isRequired,
    };

export default CriminalCheck;